var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrag = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22.04 22",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 12h6v6H7l4.04 4 4.05-4H12v-6h6.04v3l4-4.04-4-4.05V10H12V4h3.09l-4.05-4L7 4h3v6H4V6.91l-4 4.05L4 15z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag.8dfb0d71496a413ae6ad1670edab41aa.svg";